// extracted by mini-css-extract-plugin
export var borderTop = "_r-3";
export var linkIcon = "_r-5";
export var linkIconSm = "_r-6";
export var linkOutCard = "_r-7 _r-4";
export var linkRow = "_r-2";
export var pageContainer = "_r-1";
export var providerIcon = "_r-8";
export var roundedBorder = "_r-4";
export var settingsContent = "_r-0";